export const size = {
  mobileS: "320px",
  mobileM: "375px",
  mobileL: "600px",
  tablet: "768px",
  laptop: "1200px",
  laptopS: "1200px",
  laptopL: "1440px",
  desktop: "2560px",
};

export const device = {
  // note this one is exported to be used outside of this theme file.
  mobileS: `(max-width: ${size.mobileS})`,
  mobileM: `(max-width: ${size.mobileM})`,
  mobileL: `(max-width: ${size.mobileL})`,
  tablet: `(max-width: ${size.tablet})`,
  laptop: `(max-width: ${size.laptop})`,
  laptopS: `(max-width: ${size.laptopS})`,
  laptopL: `(max-width: ${size.laptopL})`,
  desktop: `(max-width: ${size.desktop})`,
  desktopL: `(max-width: ${size.desktop})`,
};
